import { View } from 'react-native';
import { ClickableLetterSquare } from './index';
import { useState } from 'react';
import { useResponsiveHeight } from '@/components/Util/reactResponsiveDimensions';

const containerClassName =
  'flex-1 flex-row flex-wrap justify-center items-center content-center';

export function ClickableLetterSquareContainer({
  isCapitallizeAll,
  splitLetters,
  onWrong,
  onCorrect,
  currentOrder,
  guessedLetters,
  wrongBoxChosen,
}) {
  // calculate size and margin of letter boxes
  let size, marginLeft;

  const [dimensions, setDimensions] = useState({ width: 1, height: 1 });

  const onLayout = (event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  };

  // max size is either the height of the container or a total of 180px
  let containerHeight = dimensions.height;
  let maxSize = Math.min(containerHeight, 180);
  let fullWidth = dimensions.width;
  let totalMaxSize = useResponsiveHeight(12.07);

  function calculateLetterSizes(fitsInOneLine) {
    let tempMaxSize;
    if (fitsInOneLine) {
      tempMaxSize = maxSize * 0.7;
    } else {
      tempMaxSize = maxSize / 2;
    }
    size = fullWidth / (splitLetters.length / 2);
    marginLeft = fullWidth / 400;
    size = size - marginLeft * 2.5;
    size = Math.min(tempMaxSize, size);

    // this limits the total size of the buttons to be simmilar to the maximum of the 'solved' buttons on top.
    // remove this line for mobile support to have maximum sized buttons.
    size = Math.min(totalMaxSize, size);
  }
  calculateLetterSizes(true);

  // check if letters fit in one line
  let fitsInOneLine = (size + marginLeft) * splitLetters.length <= fullWidth;

  // if letters dont fit in one line, re-calculate the size with an adapted maximum letter size
  if (!fitsInOneLine) {
    calculateLetterSizes(false);
  }

  // check again  if letters fit in one line after re-calculating the size
  fitsInOneLine = (size + marginLeft) * splitLetters.length <= fullWidth;
  let leftSpaceVertical;
  let leftSpaceHorizontal;
  if (fitsInOneLine) {
    leftSpaceHorizontal = fullWidth - (size + marginLeft) * splitLetters.length;
    leftSpaceVertical = containerHeight - size;
  }

  // TODO: finish logic to add random margin between letters if its possible
  let randomMarginStyles = [];
  for (let i = 0; i <= splitLetters.length; i++) {
    let randomMarginStyle = {};
    if (fitsInOneLine) {
      randomMarginStyle = {
        paddingTop:
          i % 2 ? -1 * (leftSpaceVertical / 5) : leftSpaceVertical / 3,
        paddingBottom:
          i % 2 ? leftSpaceVertical / 5 : (-1 * leftSpaceVertical) / 3,
        paddingLeft: leftSpaceHorizontal / (splitLetters.length * 2 + 4),
        paddingRight: leftSpaceHorizontal / (splitLetters.length * 2 + 4),
      };
    }
    randomMarginStyles.push(randomMarginStyle);
  }

  return (
    <View className={containerClassName} onLayout={onLayout}>
      {splitLetters.map((eachIter, index) => {
        const { key, i, letter, capitalLetter, order } = eachIter;
        const onWrongParam = index;
        return (
          <View key={index} style={randomMarginStyles[index]}>
            <ClickableLetterSquare
              key={key}
              id={i}
              isHidden={guessedLetters.includes(i)}
              currentOrder={currentOrder}
              order={order}
              letter={isCapitallizeAll ? capitalLetter : letter}
              onCorrect={onCorrect}
              onWrongParam={onWrongParam}
              onWrong={onWrong}
              size={size}
              marginLeft={marginLeft}
              wrongBoxChosen={wrongBoxChosen}
            />
          </View>
        );
      })}
    </View>
  );
}
